import type { StateManager } from '../core/StateManager';

interface GaugeElements {
  freq: HTMLElement;
  current: HTMLElement;
  dcVoltage: HTMLElement;
  temp: HTMLElement;
}

export class Gauges {
  private unsubscribers: (() => void)[] = [];

  constructor(
    state: StateManager,
    elements: GaugeElements,
  ) {
    this.unsubscribers.push(
      state.subscribe('currentFreq', (v) => {
        elements.freq.innerText = v.toFixed(1);
      }),
    );

    this.unsubscribers.push(
      state.subscribe('currentAmp', (v) => {
        elements.current.innerText = v > 100 ? v.toFixed(1) : v.toFixed(2);
      }),
    );

    this.unsubscribers.push(
      state.subscribe('dcVoltage', (v) => {
        elements.dcVoltage.innerText = Math.round(v).toString();
      }),
    );

    this.unsubscribers.push(
      state.subscribe('heatsinkTemp', (v) => {
        elements.temp.innerText = v.toFixed(1);
      }),
    );
  }

  destroy(): void {
    this.unsubscribers.forEach((fn) => fn());
    this.unsubscribers = [];
  }
}
